/*
 * @Descripttion: 
 * @version: 
 * @Author: wl
 * @Date: 2020-08-21 10:03:26
 * @LastEditors: wl
 * @LastEditTime: 2020-08-25 14:48:13
 */
import axios from '../axios'
// 预警类型  strategy_type_list
export const handleQuery = (data) => {
    return axios({
        url: '/admin/service/sys_complaint_list',
        method: 'post',
        data
    })
}
// /admin/service/sys_feedback_read   投诉意见阅读

export const handleGo = (data) => {
    return axios({
        url: '/admin/service/sys_complaint_read',
        method: 'post',
        data
    })
}


export const handleGos = (data) => {
    return axios({
        url: '/admin/service/sys_consultationAndhelp_audit',
        method: 'post',
        data
    })
}
//获取权限
export const getloca = (data) => {
    return axios({
        url: '/admin/service/organization_type_judgment',
        method: 'post',
        data
    })
}
//社区提交

export const getstyle = (data) => {
    return axios({
        url: '/admin/service/organization_related_info_add',
        method: 'post',
        data
    })
}
//社区列表

export const getlist = (data) => {
    return axios({
        url: '/admin/service/organization_related_list',
        method: 'post',
        data
    })
}
//网格添加
export const gridADD = (data) => {
    return axios({
        url: '/admin/service/grid_info_add',
        method: 'post',
        data
    })
}
//网格列表
export const gridlist= (data) => {
    return axios({
        url: '/admin/service/grid_info_list',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/suggestion.js